import React from 'react';

interface TabCounts {
	all: number;
	calls: number;
	texts: number;
	voicemails: number;
	forms: number;
}

interface TabNavigationProps {
	activeTab: string;
	onTabChange: (tab: string) => void;
	tabCounts: TabCounts;
	isLegacyIntakeFormsEnabled: boolean;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
	activeTab,
	onTabChange,
	tabCounts,
	isLegacyIntakeFormsEnabled,
}) => {
	const tabs = [
		{ name: 'All Inbox', count: tabCounts.all },
		{ name: 'Calls', count: tabCounts.calls },
		{ name: 'Texts', count: tabCounts.texts },
		{ name: 'Voicemails', count: tabCounts.voicemails },
	];

	if (isLegacyIntakeFormsEnabled) {
		tabs.push({ name: 'Intake Forms', count: tabCounts.forms });
	}

	return (
		<div className="w-full overflow-x-auto scrollbar-hide">
			<div className="flex gap-1 min-w-max">
				{tabs.map((tab) => (
					<button
						key={tab.name}
						onClick={() => onTabChange(tab.name)}
						className={`px-4 py-2 text-sm font-medium rounded-full flex items-center gap-2 transition-all duration-200 whitespace-nowrap flex-shrink-0 ${
							activeTab === tab.name
								? 'text-blue-600 shadow-sm'
								: 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
						}`}
						style={{
							backgroundColor: activeTab === tab.name ? '#EEF6FF' : 'transparent',
						}}
					>
						<span>{tab.name}</span>
						<span
							className={`text-xs px-2 py-0.5 rounded-full font-medium ${
								activeTab === tab.name ? 'bg-blue-200 text-blue-700' : 'bg-gray-200 text-gray-600'
							}`}
						>
							{tab.count}
						</span>
					</button>
				))}
			</div>
		</div>
	);
};

export default TabNavigation;
